/**
 * Needed for firefox.
 * Firefox closes all connections (XHR, Sockets...) on ESC.
 * This code prevents the default.
 */

if (window.addEventListener) {
    window.addEventListener(
        'keydown',
        (e) => {
            // 27 = ESC
            if (e.keyCode === 27) {
                e.preventDefault();
            }
        },
    );
}
